<app-view-note class="d-block table note mt-0100 mb-0050"
               *ngFor="let note of sortedNotes;"
               [note]="note"
               [noteCampaignId]="noteCampaignId"
               [targetId]="targetId"
               [targetType]="targetType"
               [preventEdit]="preventEdit"
               [truncateEnabled]="true">
</app-view-note>
<ng-container *ngIf="showNoResultsMsg && sortedNotes.length < 1">
  <div class="d-block d-none--on-old note mt-0100 color--gray">No Notes</div>
</ng-container>
